import {DatePipe}                           from '@angular/common';
import {booleanAttribute, Component, input} from '@angular/core';
import {MindRecordLogIntf}                  from '@djsharkk/logr-types';
import {TableRowBase}                       from '../table-row-base';
import {TableRow}                           from '../table-wrapper/table-wrapper.component';

@Component({
			   selector   : 'app-table-row-mind',
			   imports    : [
				   DatePipe
			   ],
			   templateUrl: './table-row-mind.component.html',
			   styleUrl   : './table-row-mind.component.css'
		   })
export class TableRowMindComponent extends TableRowBase<MindRecordLogIntf> {
	row = input.required<TableRow<MindRecordLogIntf>>();
	showDate = input(false, {transform: booleanAttribute});
	detailed = input(false, {transform: booleanAttribute});
}
